const normalizeSegments = (records) => (Array.isArray(records) ? records : [])
  .map((item) => ({
    id: item && item.id,
    name: item && (item.main_field_name || item.scyhcm6bk15ybojt),
    order: Number(item && item.order_value) || 0,
  }))
  .filter((item) => item.id && item.name)
  .sort((left, right) => left.order - right.order)
  .map(({ id, name }) => ({ id, name }));

module.exports = { normalizeSegments };



// WEBPACK FOOTER //
// ./src/util/segmentFilter.js